import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';
import { Card, CardBody, Col, Row } from "reactstrap";
import { RiCheckLine, RiCloseLine, RiMap2Line, RiQuestionLine } from "react-icons/ri";
import CorporateLinkageGraph from "./graph";

const CorporateStructure = ({
    t,
    setActiveAccordion,
    activeAccordion,
    detailsQuery
}) => {
    const organizationData = JSON.parse(detailsQuery.data?.company?.organizationData || "");

    const {
        parent,
        domestic_ultimate,
        global_ultimate,
        is_subsidiary_location,
        main_branch_indication,
        quickcheck
    } = organizationData || {};

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('corporate-structure')}
            className={activeAccordion === 'corporate-structure' ? 'active' : ''}
            eventKey={'corporate-structure'}
        >
            <Accordion.Header>
                <RiMap2Line size="24" className="me-2" />
                <span>
                    {t('Shareholders')} 
                </span>
            </Accordion.Header>

            <Accordion.Body>
                <Card className="h-100 h-100 shadow-sm">
                    <CardBody className="p-1">
                        <Row>
                            {parent ? (
                                <Col xs='12' className="mb-2">
                                    <Row className="align-items-center py-1">
                                        <Col xs='12' md='4' className="d-flex align-items-center">
                                            <div className="fw-bold text-muted">
                                                {t('Parent')}
                                            </div>
                                        </Col>
                                        <Col xs='12' md='8' className="text-start">
                                            <div className="fw-bold">
                                                {parent.trade_name} ({parent.duns}, {parent.country})
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            ) : null}

                            {domestic_ultimate ? (
                                <Col xs='12' className="mb-2">
                                    <Row className="align-items-center py-1">
                                        <Col xs='12' md='4' className="d-flex align-items-center">
                                            <div className="fw-bold text-muted">
                                                {t('Domestic Ultimate')}
                                            </div>
                                        </Col>
                                        <Col xs='12' md='8' className="text-start">
                                            <div className="fw-bold">
                                                {domestic_ultimate.trade_name} ({domestic_ultimate.duns}, {domestic_ultimate.country})
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            ) : null}

                            {global_ultimate ? (
                                <Col xs='12' className="mb-2">
                                    <Row className="align-items-center py-1">
                                        <Col xs='12' md='4' className="d-flex align-items-center">
                                            <div className="fw-bold text-muted">
                                                {t('Global Ultimate')}
                                            </div>
                                        </Col>
                                        <Col xs='12' md='8' className="text-start">
                                            <div className="fw-bold">
                                                {global_ultimate.trade_name} ({global_ultimate.duns}, {global_ultimate.country})
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            ) : null}

                            <Col xs='12' className="mb-2">
                                <Row className="align-items-center py-1">
                                    <Col xs='12' md='4' className="d-flex align-items-center">
                                        <div className="fw-bold text-muted">
                                            {t('Subsidiary Status')}
                                        </div>
                                    </Col>
                                    <Col xs='12' md='8' className="text-start">
                                        <div className="fw-bold">
                                            {is_subsidiary_location === true ? (
                                                <>
                                                    <RiCheckLine size={20} className="text-primary" />
                                                    {t('Yes')}
                                                </>
                                            ) : is_subsidiary_location === false ? (
                                                <>
                                                    <RiCloseLine size={20} className="text-danger" />
                                                    {t('No')}
                                                </>
                                            ) : (
                                                <>
                                                    <RiQuestionLine size={20} className="text-secondary" />
                                                    {t('Unknown')}
                                                </>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </Col>

                            <Col xs='12' className="mb-2">
                                <Row className="align-items-center py-1">
                                    <Col xs='12' md='4' className="d-flex align-items-center">
                                        <div className="fw-bold text-muted">
                                            {t('Main Branch')}
                                        </div>
                                    </Col>
                                    <Col xs='12' md='8' className="text-start">
                                        <div className="fw-bold">
                                            {main_branch_indication === true ? (
                                                <>
                                                    <RiCheckLine size={20} className="text-primary" />
                                                    {t('Yes')}
                                                </>
                                            ) : main_branch_indication === false ? (
                                                <>
                                                    <RiCloseLine size={20} className="text-danger" />
                                                    {t('No')}
                                                </>
                                            ) : (
                                                <>
                                                    <RiQuestionLine size={20} className="text-secondary" />
                                                    {t('Unknown')}
                                                </>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                
                {domestic_ultimate && global_ultimate && parent ? (
                    <Card>
                        <CardBody>
                            <CorporateLinkageGraph 
                                domesticUltimate={domestic_ultimate}
                                globalUltimate={global_ultimate}
                                parent={parent}
                                currentCompany={{
                                    duns: quickcheck.duns,
                                    trade_name: quickcheck.trade_name
                                }}
                            />
                        </CardBody>
                    </Card>
                ) : null}
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default withNamespaces()(
    CorporateStructure
);